import { type DOMProps, Text } from "@simplybusiness/mobius";
import classNames from "classnames/dedupe";
import type React from "react";
import type { RefAttributes } from "react";
import type { WithMetadata } from "../../pages";

export type AgentInformationElement = HTMLDivElement;

export interface AgentInformationProps
  extends DOMProps, RefAttributes<AgentInformationElement> {
  /** Custom class name for setting specific CSS */
  className?: string;
  elementType?: React.ElementType;
}

export const AgentInformation = ({
  ref,
  ...props
}: WithMetadata<AgentInformationProps>) => {
  const { elementType: Element = "div", componentName, ...otherProps } = props;

  const classes = classNames(
    "mobius",
    "mobius-agent-information",
    otherProps.className,
  );
  const { variant } = otherProps;

  return (
    <Element
      ref={ref}
      {...otherProps}
      {...(componentName ? { "data-component": componentName } : {})}
      {...(variant ? { "data-variant": variant } : {})}
      className={classes}
    >
      <Text>
        You should receive an email with this information in about 5 minutes. It
        includes a link to return to the quote.
      </Text>
      <Text>
        <strong>Please note that this email will not go to your client</strong>
      </Text>
      <Text>
        <strong>
          If you share the quote email with your client and they would like to
          purchase, you will need to complete the binding process on behalf of
          your client by clicking the &ldquo;Select&ldquo; button above and
          entering the client&lsquo;s credit card information.
        </strong>
      </Text>
    </Element>
  );
};

AgentInformation.displayName = "AgentInformation";
